import React from 'react';
interface StatusBadgeProps {
  status: 'approved' | 'pending' | 'rejected' | 'verified' | 'processing' | 'completed';
  size?: 'sm' | 'md';
}
export function StatusBadge({
  status,
  size = 'md'
}: StatusBadgeProps) {
  const sizeClasses = size === 'sm' ? 'text-[10px] px-2 py-0.5 tracking-wide uppercase' : 'text-xs px-3 py-1 tracking-wide uppercase';
  const statusConfig = {
    approved: {
      bg: 'bg-[#00D68F]/10',
      text: 'text-[#00D68F]',
      ring: 'ring-1 ring-inset ring-[#00D68F]/20',
      label: 'Approved'
    },
    pending: {
      bg: 'bg-[#FFBE0B]/10',
      text: 'text-[#FFBE0B]',
      ring: 'ring-1 ring-inset ring-[#FFBE0B]/20',
      label: 'Pending'
    },
    rejected: {
      bg: 'bg-[#FF4757]/10',
      text: 'text-[#FF4757]',
      ring: 'ring-1 ring-inset ring-[#FF4757]/20',
      label: 'Rejected'
    },
    verified: {
      bg: 'bg-[#00D68F]/10',
      text: 'text-[#00D68F]',
      ring: 'ring-1 ring-inset ring-[#00D68F]/20',
      label: '✓ Verified'
    },
    processing: {
      bg: 'bg-[#4CC9F0]/10',
      text: 'text-[#4CC9F0]',
      ring: 'ring-1 ring-inset ring-[#4CC9F0]/20',
      label: 'Processing'
    },
    completed: {
      bg: 'bg-[#00D68F]/10',
      text: 'text-[#00D68F]',
      ring: 'ring-1 ring-inset ring-[#00D68F]/20',
      label: 'Completed'
    }
  };
  const config = statusConfig[status];
  return <span className={`inline-flex items-center rounded-full font-semibold ${sizeClasses} ${config.bg} ${config.text} ${config.ring}`} data-id="element-82">
      {config.label}
    </span>;
}